// extracted by mini-css-extract-plugin
export default {"wrapper":"ForgotPassword_wrapper__PzAkP","title":"ForgotPassword_title__H8X1q","btnWrapper":"ForgotPassword_btnWrapper__8wC+3"};